import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminWorkDetail(workId) {
    return useQuery({
        queryKey: adminKeys.workDetail(workId),
        queryFn: () => adminApi.getWorkDetail(workId),
        enabled: !!workId,
    });
}
